// import backgroundImage from "../assets/homebackground.jpg"
import backgroundImage from "../assets/choose-your-element-background.gif"

function Home() {
    return (
        <img id="homeImg" src={backgroundImage} alt="main shoe GIF"></img>
    )
}

export default Home;